import {
    Message
} from "element-ui";
import {
    getFundCache,
    getFundRank
} from "../../api/ranking";
import starrating0 from "../../../public/images/smallstar0.gif";
import starrating1 from "../../../public/images/smallstar1.gif";
import starrating2 from "../../../public/images/smallstar2.gif";
import starrating3 from "../../../public/images/smallstar3.gif";
import starrating4 from "../../../public/images/smallstar4.gif";
import starrating5 from "../../../public/images/smallstar5.gif";

const componentsCommon = require("cb-components-common").default;
const checkResponseStatus = componentsCommon.common.checkResponseStatus;

export const loadingData = {
    props: ['latestRatio'],
    data() {
        return {
            rankingRatio: "",
            myListCompanyDaily: [],
            myListCompanyMonthly: []
        }
    },
    methods: {
        getCategoryNoRankingMsg() {
            return "该类型基金不参与排名";
        },
        getNavOutlierMsg() {
            return "疑似净值异常波动，不参与排名";
        },
        showNavOutlier(returnValue, showNoRankingIcon, navoutlier,significantRestructure) {
            if(significantRestructure){
                return true;
            }
            return returnValue && !showNoRankingIcon && (navoutlier != null && navoutlier);
        },
        showTooltipContent(returnValue, showNoRankingIcon, navoutlier,significantRestructure){
            if(showNoRankingIcon)
            {
                return this.getCategoryNoRankingMsg();
            }
            
            if(significantRestructure){
                return "基金该回报期间内发生策略变更，不参与排名";
            }
            let isNavoutLier=returnValue && !showNoRankingIcon && (navoutlier != null && navoutlier);
            if(isNavoutLier){
                return "疑似净值异常波动，不参与排名";
            }
            return "";
        },

        rankTooltip(value) {
            if (value) {
                return value;
            } else {
                return "--"
                //return "<span class='el-icon-warning-outline' title='疑似净值异常波动，不参与排名'></span>";
            }
        },
        handleSelect(key, keyPath) {
            const self = this;
            self.getData(self.params);
        },
        handleSizeChange(val) {
            const self = this;
            self.params.limit = val;
            self.getData(self.params);
        },
        handleCurrentChange(val) {
            const self = this;
            self.params.page = val;
            self.params.skip = (val - 1) * self.params.limit;
            self.getData(self.params);
        },
        sortChange(column, prop, order) {
            let self = this;
            if (column.order != undefined) {
                self.params.order = column.order
                    .replace("ascending", "asc")
                    .replace("descending", "desc");
                self.params.sort = column.prop;
                self.getData(self.params);
            }
            console.log(column + "-" + column.prop + "-" + column.order);
        },
        renderheader2Row(h, {
            column,
            $index
        }) {
            var self = this;

            return h("span", {}, [
                h("span", {}, column.label.split("|")[0]),
                h("br"),
                h("span", {}, column.label.split("|")[1]),
            ]);
        },
        renderheader3Row(h, {
            column,
            $index
        }) {
            return h("span", {}, [
                h("span", {}, column.label.split("|")[0]),
                h("br"),
                h("span", {}, column.label.split("|")[1]),
                h("br"),
                h("span", {}, column.label.split("|")[2]),
            ]);
        },
        renderheaderRefreshData(h, {
            column,
            $index
        }) {
            var self = this;
            // console.log("renderheaderRefreshData->showNoRankingIcon",self.showNoRankingIcon);
            if (self.showNoRankingIcon) {
                //for refresh attribute showNoRankingIcon 
            }
            if (self.ratingDate) {
                //refresh ratingDate
            }
            if (self.showNoRatingIcon) {
                //refresh showNoRatingIcon
            }

            return [column.label]
        },
        getStarRating(starRating) {
            let self = this;
            switch (starRating) {
                case "0":
                    return starrating0;
                    break;
                case "1":
                    return starrating1;
                    break;
                case "2":
                    return starrating2;
                    break;
                case "3":
                    return starrating3;
                    break;
                case "4":
                    return starrating4;
                    break;
                case "5":
                    return starrating5;
                    break;
            }
        },
        checkDataHasValue(value) {
            if (value != undefined && value != null && value != "") {
                return true;
            } else {
                return false;
            }
        },
        formatBooleanFlag(value) {
            if (value === true || value === "true" || value === 1 || value === "1") {
                return "是";
            }
            if (value === false || value === "false" || value === 0 || value === "0") {
                return "否";
            }
            return "--";
        },
        resetPaginationParameter() {
            const self = this;
            self.params.limit = 10;
            self.params.skip = 0;
            self.params.page = 1;
        },
        getData(params) {
            const self = this;
            self.loading = true;
            self.tableDataLazyloading = false;
            getFundRank(params)
                .then((response) => {
                    let result = response.data;
                    if (result == undefined) {
                        Message({
                            message: "数据异常，请尝试刷新再试！",
                            type: "error",
                            duration: 2 * 1000,
                        });
                        Message.close = function() {};
                    } else {
                        if (checkResponseStatus(result, self)) {
                            if (
                                Number(result._meta.response_status) === 200032
                            ) {
                                Message({
                                    message: "非常抱歉，数据正在更新中，请稍后再试！",
                                    type: "warning",
                                    duration: 3 * 1000,
                                });
                                Message.close = function() {};
                            } else {
                                self.pagination = result.pagination;
                                self.pageSize = result.pagination.count;
                                self.tableDataLazyloading = true;
                                self.rankingRatio =
                                    "净值更新比例：" +
                                    result.data.latestRatio +
                                    "%";
                                self.$emit("changeRankingRatio", "净值更新比例：" +
                                    result.data.latestRatio +
                                    "%");

                                if (result.data.categoryNoRanking != null && result.data.categoryNoRanking) {
                                    self.showNoRankingIcon = result.data.categoryNoRanking;
                                } else {
                                    self.showNoRankingIcon = false;
                                }

                                if (result.data.categoryNoRating != null && result.data.categoryNoRating) {
                                    self.showNoRatingIcon = result.data.categoryNoRating;
                                } else {
                                    self.showNoRatingIcon = false;
                                }

                                if (result.data.ratingYear != null) {
                                    self.ratingDate = result.data.ratingYear + '年' + result.data.ratingMonth + '月';
                                } else {
                                    self.ratingDate = '-年-月';
                                }
                                self.tableData = result.data.rankInfo;
                            }
                        }
                    }
                })
                .catch((err) => {
                    Message({
                        message: "数据异常，请尝试刷新再试！",
                        type: "error",
                        duration: 2 * 1000,
                    });
                    Message.close = function() {};
                })
                .finally((r) => {
                    self.loading = false;
                });
        },
        handleRemoveCompanyDaily(companyName) {
            const self = this;
            let index = self.myListCompanyDaily.indexOf(companyName);
            if (index != -1) self.myListCompanyDaily.splice(index, 1);

            self.$refs.scrollbarMyList.update();            
        },
        handleRemoveCompanyMonthly(companyName) {
            const self = this;
            let index = self.myListCompanyMonthly.indexOf(companyName);
            if (index != -1) self.myListCompanyMonthly.splice(index, 1);

            self.$refs.scrollbarMyListMonthly.update();            
        },
        handleAddCompanyDaily(companyName) {
            const self = this;
            if (companyName) {        
                if (self.myListCompanyDaily === null || self.myListCompanyDaily == "" || self.myListCompanyDaily == undefined) {
                    self.myListCompanyDaily = [];
                }
                self.myListCompanyDaily.push(companyName);
                self.companyName = "";
                self.$refs.scrollbarMyListDaily.update();
            }
        },
        handleAddCompanyMonthly(companyName) {
            const self = this;
            if (companyName) {        
                if (self.myListCompanyMonthly === null || self.myListCompanyMonthly == "" || self.myListCompanyMonthly == undefined) {
                    self.myListCompanyMonthly = [];
                }
                self.myListCompanyMonthly.push(companyName);
                self.companyName = "";
                self.$refs.scrollbarMyListMonthly.update();
            }
        },
        fiterCompanyDaily(query) {
            const self = this;
            if (query !== "") {
                self.filteredCompanyListDaily = self.companyList.filter(item => {
                    return (
                        ( item.companyNamePhonetic !=null && item.companyName !=null ) 
                        &&
                        ( item.companyNamePhonetic
                              .toLowerCase()
                              .indexOf(query.toLowerCase()) > -1 ||
                          item.companyName.indexOf(query) > -1 )
                    );
                });
            } else {
                self.filteredCompanyListDaily = self.companyList;
            }
        },
        fiterCompanyMonthly(query) {
            const self = this;
            if (query !== "") {
                self.filteredCompanyListMonthly = self.companyList.filter(item => {
                    return (
                        ( item.companyNamePhonetic !=null && item.companyName !=null ) 
                        &&
                        ( item.companyNamePhonetic
                              .toLowerCase()
                              .indexOf(query.toLowerCase()) > -1 ||
                          item.companyName.indexOf(query) > -1 )
                    );
                });
            } else {
                self.filteredCompanyListMonthly = self.companyList;
            }
        },
    }
}
